import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../core/ComponentSync.js';
import { TS_Input } from '../components/TS_Input/TS_Input.js';
import { TS_TextArea } from '../components/TS_Input/TS_TextArea.js';
export class FieldEditor extends ComponentSync {
    constructor(props) {
        super(props);
        const prevValue = this.props.storageKey.get();
        if (!prevValue) {
            // this.logDebug(`FieldEditor: ${this.props.value}`);
            this.props.storageKey.set(this.props.value || '');
        }
    }
    deriveStateFromProps(nextProps) {
        return {};
    }
    onChange = (value) => {
        // this.logDebug(`input onChange: ${value}`);
        this.props.storageKey.set(value);
        this.forceUpdate();
    };
    renderInput = (value) => {
        // @ts-ignore
        return (_jsx(TS_Input, { ...this.props.inputProps, focus: true, id: this.props.id, type: this.props.type, onAccept: this.props.onAccept, value: value, onChange: this.onChange }));
    };
    renderArea = (value) => {
        // @ts-ignore
        return (_jsx(TS_TextArea, { ...this.props.inputProps, focus: true, id: this.props.id, type: this.props.type, onAccept: this.props.onAccept, value: value, onChange: this.onChange }));
    };
    renderLabel = () => {
        const label = this.props.value || this.props.inputProps?.placeholder || '';
        if (typeof this.props.labelProps === 'function')
            return this.props.labelProps(label);
        return _jsx("div", { ...this.props.labelProps, children: label });
    };
    render() {
        const value = this.props.storageKey.get() || '';
        if (!this.props.isEditing)
            return this.renderLabel();
        switch (this.props.editorType || 'input') {
            case 'input':
                return this.renderInput(value);
            case 'textarea':
                return this.renderArea(value);
        }
    }
}
//# sourceMappingURL=FieldEditor.js.map